import React from 'react';
import { inject, observer } from 'mobx-react';

@inject('portalThemeStore')
@observer
class E9TopLogo extends React.Component {
  render() {
    const { portalThemeStore } = this.props;
    const { themeInfo } = portalThemeStore;
    const { themeLogo, themeLogoName, themeData = {} } = themeInfo;
    const { styleConfig = {} } = themeData;
    const { toplogo = {} } = styleConfig;
    const fontSize = parseInt(toplogo.fontSize || '14px');

    return (
      <div className={`e9header-top-logo wea-f${fontSize}`}>
        {themeLogo ? <img src={themeLogo} alt="" /> : <span>{themeLogoName}</span>}
      </div>
    );
  }
}

export default E9TopLogo;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/E9TopLogo.js